import React, { useState, useEffect } from "react";
import Map from "./Map";
import { Layers, TileLayer, /*, VectorLayer*/ VectorLayer } from "./Layers";
import { Controls, FullScreenControl, ZoomControl } from "./Controls";

import "./assets/css/App.css";
import "./assets/css/listeavis.css";
import { Grid } from "@mui/material";
import config from "./config";
import Accueil from "./composants/Accueil";
import MenuDroite from "./composants/MenuDroite";

import esri from "./Source/esri";

import FormationPluridisciplinaireStyle from "./Styles/FormationPluridisciplinaire";
import FormationPluridisciplinaire from "./Source/FormationPluridisciplinaire";
import CentreESport from './Source/CentreEsport'
import CentreESportStyle from './Styles/CentreESportStyle'
import Distributeur from './Source/Distributeur'
import DistributeurStyle from './Styles/DistributeurStyle'
import Studio from './Source/Studio'
import StudioStyle from './Styles/StudioStyle'
import Editeur from './Source/Editeur'
import EditeurStyle from './Styles/EditeurStyle'
import FormationEsport from './Source/FormationEsport'
import FormationEsportStyle from './Styles/FormationEsport'
import FormationInformatique from './Source/FormationInformatique'
import FormationInformatiqueStyle from './Styles/FormationInformatique'
// import MapContext from "./Map/MapContext";
import { useMatomo } from '@datapunt/matomo-tracker-react' 



const App = () => {

  const { trackPageView } = useMatomo()

  // Track page view
  useEffect(() => {
    trackPageView({
      documentTitle: 'Websig filière jeux vidéo', // optional
      href: document.location.href, // optional
    })
  }, [])
  
  // const [center, setCenter] = useState(config.center);
  // const [zoom] = useState(config.zoom);
  const [mapInstance, setMapInstance] = useState(null);

  return (
    <Grid direction="row" container className="interface">
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className={"entete_totale"}>
        <Accueil/>
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="corps">
        <Grid className="container__map__et__menu" container>
          <Grid  item xs={12} sm={12} md={8} lg={9} xl={9}>
            <Map
              center={config.center}
              zoom={config.center}
              // setCenter={setCenter}
              className="carte"
              setMapInstance={setMapInstance}
            >
              <Layers>
                <TileLayer source={new esri()} zIndex={0}  />
                <VectorLayer
                  source={FormationPluridisciplinaire}
                  style={FormationPluridisciplinaireStyle}
                  zIndex={1}
                  type={"Formation pluridisciplinaire"}
                />
                <VectorLayer
                  source={Studio}
                  style={StudioStyle}
                  zIndex={2}
                  type={"Studio"}
                />
                <VectorLayer
                  source={CentreESport}
                  style={CentreESportStyle}
                  zIndex={3} 
                  type={"Esport"}
                />
                <VectorLayer
                  source={FormationEsport}
                  style={FormationEsportStyle}
                  zIndex={4}
                  type={"Formation esport"}
                />
                <VectorLayer
                  source={Distributeur}
                  style={DistributeurStyle}
                  zIndex={5} 
                  type={"Distributeur"}
                />
                <VectorLayer
                  source={FormationInformatique}
                  style={FormationInformatiqueStyle}
                  zIndex={6}
                  type={"Formation informatique"}
                />
                <VectorLayer
                  source={Editeur}
                  style={EditeurStyle}
                  zIndex={7}
                  type={"Editeur"}
                />
              </Layers>
              <Controls>
                <FullScreenControl />
                <ZoomControl />
              </Controls>
            </Map>
          </Grid>

          <Grid
            className="accueil_page_droite"
            item
            xs={3}
            sm={3}
            md={3}
            lg={3}
            xl={3}
          >
            <MenuDroite map={mapInstance}/>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default App;
